import type { AgentRuntimeStatus } from "../../hooks/useAgentRuntime";

type RuntimeStatusBadgeProps = {
  runtime: AgentRuntimeStatus | null | undefined;
  isLoading?: boolean;
  isEnsuring?: boolean;
};

function runtimeLabel(runtime: AgentRuntimeStatus | null | undefined): string {
  if (!runtime) return "HelloConvo Agent status unknown";
  switch (runtime.state) {
    case "cold":
      return "Preparing HelloConvo Agent";
    case "starting":
      return "Preparing HelloConvo Agent";
    case "ready":
      return "HelloConvo Agent ready";
    case "degraded":
      return "HelloConvo Agent limited";
    case "failed":
      return "HelloConvo Agent unavailable";
    default:
      return "HelloConvo Agent status unknown";
  }
}

function runtimeDotClass(runtime: AgentRuntimeStatus | null | undefined): string {
  if (!runtime) return "bg-slate-400";
  switch (runtime.state) {
    case "cold":
      return "bg-slate-400";
    case "starting":
      return "bg-blue-500";
    case "ready":
      return "bg-emerald-500";
    case "degraded":
      return "bg-amber-500";
    case "failed":
      return "bg-red-500";
    default:
      return "bg-slate-400";
  }
}

export function RuntimeStatusBadge({
  runtime,
  isLoading = false,
  isEnsuring = false,
}: RuntimeStatusBadgeProps) {
  const label = isLoading && !runtime
    ? "Checking HelloConvo Agent"
    : `${runtimeLabel(runtime)}${isEnsuring && runtime?.state !== "ready" ? "…" : ""}`;
  return (
    <span
      role="status"
      aria-label={label}
      title={label}
      className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-slate-200 bg-white"
    >
      <span aria-hidden="true" className={`h-2.5 w-2.5 rounded-full ${runtimeDotClass(runtime)}`} />
      <span className="sr-only">{label}</span>
    </span>
  );
}
